import React from 'react';
import { Button } from './ui/Button';
import { ArrowRight, Shield, Scale, FileText } from 'lucide-react';
export function Hero() {
  return <div className="relative min-h-[85vh] flex items-center pt-32 pb-20 bg-white overflow-hidden" data-id="element-142">
      {/* Subtle geometric background pattern - hidden on mobile to prevent overflow */}
      <div className="absolute inset-0 opacity-[0.03] hidden lg:block" data-id="element-143">
        <div className="absolute top-20 left-10 w-64 h-64 border border-black rounded-full" data-id="element-144"></div>
        <div className="absolute bottom-20 right-20 w-96 h-96 border border-black" data-id="element-145"></div>
        <div className="absolute top-1/2 left-1/3 w-48 h-48 border border-black rotate-45" data-id="element-146"></div>
      </div>

      {/* Decorative icons - hidden on mobile */}
      <div className="absolute top-32 right-12 opacity-5 hidden xl:block" data-id="element-147">
        <Shield className="h-32 w-32 text-black" data-id="element-148" />
      </div>
      <div className="absolute bottom-32 left-12 opacity-5 hidden xl:block" data-id="element-149">
        <Scale className="h-24 w-24 text-black" data-id="element-150" />
      </div>

      <div className="container mx-auto px-6 md:px-8 max-w-7xl relative z-10" data-id="element-151">
        <div className="max-w-4xl" data-id="element-152">
          <div className="inline-block mb-6 md:mb-8 animate-in fade-in slide-in-from-bottom-4 duration-700" data-id="element-153">
            <span className="py-1 border-b border-black text-xs md:text-sm font-medium text-black uppercase tracking-wider" data-id="element-154">
              Юридичний захист військовослужбовців
            </span>
          </div>

          <h1 className="text-4xl sm:text-5xl md:text-7xl lg:text-8xl font-bold text-black leading-[0.95] tracking-tight mb-6 md:mb-8 animate-in fade-in slide-in-from-bottom-6 duration-700 delay-100" data-id="element-155">
            Захищаємо <br data-id="element-156" />
            ваші права.
          </h1>

          <p className="text-lg sm:text-xl md:text-2xl text-neutral-500 mb-8 md:mb-12 leading-relaxed max-w-2xl font-light animate-in fade-in slide-in-from-bottom-8 duration-700 delay-200" data-id="element-157">
            Кваліфікована допомога адвокатів у справах ТЦК, ВЛК та військової
            служби. Професійний підхід до складних ситуацій.
          </p>

          <div className="flex flex-col sm:flex-row gap-3 md:gap-4 items-stretch sm:items-start animate-in fade-in slide-in-from-bottom-10 duration-700 delay-300" data-id="element-158">
            <Button variant="primary" size="lg" className="w-full sm:w-auto" onClick={() => document.getElementById('contact')?.scrollIntoView({
            behavior: 'smooth'
          })} rightIcon={<ArrowRight className="h-4 w-4" data-id="element-160" />} data-id="element-159">
              Отримати консультацію
            </Button>
            <Button variant="outline" size="lg" className="w-full sm:w-auto" onClick={() => document.getElementById('services')?.scrollIntoView({
            behavior: 'smooth'
          })} data-id="element-161">
              Дізнатися більше
            </Button>
          </div>

          {/* Trust indicators */}
          <div className="mt-12 md:mt-16 pt-6 md:pt-8 border-t border-neutral-100 grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-8 animate-in fade-in duration-700 delay-500" data-id="element-162">
            <div className="flex items-center gap-3" data-id="element-163">
              <Shield className="h-4 md:h-5 w-4 md:w-5 text-black flex-shrink-0" data-id="element-164" />
              <span className="text-xs md:text-sm text-neutral-600" data-id="element-165">
                12+ років досвіду
              </span>
            </div>
            <div className="flex items-center gap-3" data-id="element-166">
              <Scale className="h-4 md:h-5 w-4 md:w-5 text-black flex-shrink-0" data-id="element-167" />
              <span className="text-xs md:text-sm text-neutral-600" data-id="element-168">
                500+ справ
              </span>
            </div>
            <div className="flex items-center gap-3" data-id="element-169">
              <FileText className="h-4 md:h-5 w-4 md:w-5 text-black flex-shrink-0" data-id="element-170" />
              <span className="text-xs md:text-sm text-neutral-600" data-id="element-171">
                92% успіху
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>;
}